import { Step } from "react-joyride";

const waitFor = (selector: string, timeoutMs = 2000): Promise<void> =>
  new Promise((resolve) => {
    if (document.querySelector(selector)) {
      resolve();
      return;
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();
      resolve();
    }, timeoutMs);
  });

const openCrm = async () => {
  if (document.querySelector(".tour-nav-crm-contacts")) return;
  (document.querySelector(".tour-nav-crm") as HTMLElement | null)?.click();
  await waitFor(".tour-nav-crm-contacts");
};

const closeCrm = () => {
  if (!document.querySelector(".tour-nav-crm-contacts")) return;
  (document.querySelector(".tour-nav-crm") as HTMLElement | null)?.click();
};

const sidenavTourSteps: Step[] = [
  {
    target: ".tour-nav-map-view-map",
    content: "Opens our integrated Maps feature. View, measure, and share job site maps.",
  },
  {
    target: ".tour-nav-takeoffs",
    content: "Add and measure from blueprints for new construction.",
  },
  {
    target: ".tour-nav-crm",
    content: "Manage and organize your customer interactions.",
  },
  {
    target: ".tour-nav-crm-contacts",
    content: "An organized list of current and potential customers.",
    before: openCrm,
  },
  {
    target: ".tour-nav-crm-opportunities",
    content: "Track leads, requests, and potential jobs for existing or new customers.",
  },
  {
    target: ".tour-nav-tasks-list",
    content: "A to-do list. Created from existing Notification Triggers and manual inputs.",
    after: closeCrm,
  },
  {
    target: ".tour-nav-proposals",
    content: "View, create, and edit your proposals. Also referred to as estimates or bids.",
  },
  {
    target: ".tour-nav-jobs",
    content: "Manage your jobs from start to finish after winning a Proposal.",
  },
  {
    target: ".tour-nav-jobs-schedule",
    content:
      "View and schedule your jobs. Generate Work Orders and send the Job Details to your field crews.",
  },
  {
    target: ".tour-nav-jobs-dispatch",
    content:
      "Track job readiness, checklist completion, material needs, and trucking demands to better coordinate jobs.",
  },
  {
    target: ".tour-nav-fleet-management",
    content: "Add Daily Vehicle Inspections or Shop Tasks. Available to your field crews.",
  },
  {
    target: ".tour-nav-organization",
    content: "Manage all your costs for Equipment, Crews, Materials, and Trucking.",
  },
  {
    target: ".tour-nav-organization-settings",
    content:
      "All of your Organization Settings like Managing Users, Organization Information (Including Logo), Proposal Terms, Email Settings, etc.",
  },
  {
    target: ".tour-nav-time-tracking",
    content: "Clock in and out of jobs. Available for crew use in the Bitumio mobile app.",
  },
  {
    target: ".tour-nav-knowledge-base",
    content: "Read articles for self-help. Made in conjunction with our videos on YouTube.",
  },
];

export default sidenavTourSteps;
